// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__EuW9K","header":"ReportDetails_header__TNE9K","title":"ReportDetails_title__m1t71","left":"ReportDetails_left__2Puro"};